var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"learn-view"}},[_c('div',{staticClass:"box"},[_c(_vm.calculationType.learn,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }